import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from '@/constants/routes';
import { buildSuiteLoungeEntryPath } from '@/hooks/useSuiteLoungeFlow';
import { useSuiteLoungeSessionReset } from '@/hooks/useSuiteLoungeSessionReset';

/**
 * 会員種別の判明を待つ上限。
 *
 * /users/me はリトライ無効かつ fetch のタイムアウトが60秒(utils/retry.ts)のため、
 * 上限を設けないと回線が遅い場合に最大60秒この画面(白画面)で止まる。
 *
 * 上限で切り上げても、遷移先の LoginForm が上限なしで待ち直すため
 * ログアウト判定自体は取りこぼさない。
 */
const MEMBERSHIP_RESOLVE_TIMEOUT_MS = 3000;

// SLのログイン or 会員登録導線エントリーポイントコンポーネント
export const SuiteLoungeEntrypoint = () => {
  const navigate = useNavigate();
  const { isMembershipUnknown, resetSession } = useSuiteLoungeSessionReset();
  const [hasResolveTimedOut, setHasResolveTimedOut] = useState(false);
  const hasHandledRef = useRef(false);

  useEffect(() => {
    const timer = setTimeout(
      () => setHasResolveTimedOut(true),
      MEMBERSHIP_RESOLVE_TIMEOUT_MS,
    );

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (hasHandledRef.current) return;
    // 会員種別が判明するまでリダイレクトを待つ(上限あり)。
    // 先に遷移してしまうとAL会員のセッションを破棄できないため。
    if (isMembershipUnknown && !hasResolveTimedOut) return;

    hasHandledRef.current = true;

    // AL資格でログイン済みの場合はセッションを破棄し、SL会員のログイン導線に乗せる
    resetSession();

    navigate(buildSuiteLoungeEntryPath(ROUTE_PATH.LOGIN), { replace: true });
  }, [isMembershipUnknown, hasResolveTimedOut, resetSession, navigate]);

  return null; // リダイレクト中は何も表示しない
};
